export const MAIN_GROUP_ID = 1
